// herolast.jsx
import React from "react";
import "../css/herolast.css";
import herolastbg from "../assets/homelastbg.jpg";

export default function HeroLast() {
  const phoneDisplay = "72378 98275";
  const telHref = "tel:7237898275";

  return (
    <section
      className="herolast-section"
      style={{ backgroundImage: `url(${herolastbg})` }}
      aria-labelledby="herolast-heading"
    >
      <div className="herolast-overlay" />

      <div className="herolast-inner container">
        <div className="herolast-card" role="region" aria-labelledby="herolast-heading">
          <h2 id="herolast-heading" className="herolast-title">
            Ready to Experience Comfort Like Never Before?
          </h2>

          <p className="herolast-sub">
            Contact us today for all your air conditioning needs and enjoy our exceptional services.
          </p>

          <a className="herolast-phone" href={telHref} aria-label={`Call ${phoneDisplay}`}>
            {phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
}
